// Accordion Component
const accordions = document.querySelectorAll('.accordion');

	accordions.forEach((accordion) => {
		const content = accordion.querySelector('.accordion-content');
		const accordionHide = accordion.querySelector('.accordion-hide');
		const accordionShow = accordion.querySelector('.accordion-show');
		const subcollectionBtn = accordion.querySelector('.subcollection-btn');
		const accordionArrow = accordion.querySelector('.accordion-arrow');
		const subcollectionWrapper = accordion.querySelector('.subcollections-wrapper');

		if (accordionHide) {
			accordionHide.addEventListener('click', () => {
				content.style.display = content.style.display === 'none' ? 'block' : 'none';
				content.style.height = content.style.height === '0px' ? 'auto' : '0px';
				accordionHide.style.display = accordionHide.style.display === 'block' ? 'none' : 'block';
				accordionShow.style.display = accordionShow.style.display === 'none' ? 'block' : 'none';
				accordionArrow.style.transform = accordionArrow.style.transform === 'none' ? 'rotate(180deg)' : 'none';
			});
		}

		if (accordionShow) {
			accordionShow.addEventListener('click', () => {
				content.style.display = content.style.display === 'none' ? 'block' : 'none';
				content.style.height = content.style.height === '0px' ? 'auto' : '0px';
				accordionHide.style.display = accordionHide.style.display === 'block' ? 'none' : 'block';
				accordionShow.style.display = accordionShow.style.display === 'none' ? 'block' : 'none';
				accordionArrow.style.transform = accordionArrow.style.transform === 'none' ? 'rotate(180deg)' : 'none';
	
			});
		}

		if (subcollectionBtn) {
			subcollectionBtn.addEventListener('click', () => {
				const paddingTop = window.innerWidth < 750 ? '24px' : '54px';
				const paddingBottom = window.innerWidth < 750 ? '0px' : '54px';
				// content.style.display = content.style.display === 'none' ? 'block' : 'none';
				content.style.height = content.style.height === '0px' ? 'auto' : '0px';
				content.style.paddingTop = content.style.paddingTop > '0px' || content.style.paddingTop === paddingTop ? '0px' : paddingTop;
				// content.style.paddingBottom = content.style.paddingBottom > '0px' || content.style.paddingBottom === paddingBottom ? '0px' : paddingBottom;
				accordionArrow.style.transform = accordionArrow.style.transform === 'none' ? 'rotate(180deg)' : 'none';
				subcollectionWrapper.style.maxHeight = subcollectionWrapper.style.maxHeight === '0px' ? '100%' : '0px';
				subcollectionWrapper.style.height = subcollectionWrapper.style.height === '0px' ? '100%' : '0px';
				subcollectionWrapper.style.opacity = subcollectionWrapper.style.opacity === '0' ? '1' : '0';
				subcollectionWrapper.style.visibility = subcollectionWrapper.style.visibility === 'hidden' ? 'visible' : 'hidden';
			});
		}


	});

// Instafeed App Component 

// console log instafeed 5 seconds after page load
setTimeout(() => {
	if (document.querySelector('.instastory-title')) {
		const instafeedTitle = document.querySelector('.instastory-title');
		instafeedTitle.style = "text-align: left; font-size: 21px;font-weight: 600;line-height: 120%;"
		if ($(window).width() < 749) {
			instafeedTitle.style = "text-align: center; font-size: 21px;font-weight: 600;line-height: 120%;"
		}

		// const feedImages = $("#instafeed li.glide__slide .splide-img")
		// for (var key in feedImages) {
		//   if (feedImages.hasOwnProperty(key)) {
		//       console.log(key + " -> " + feedImages[key]);
		// 			feedImages[key].style = "width: 100%;height: 333px;object-fit: cover;"
		//   }
		// }
		// const instafeedGrid = document.querySelector('.instagram-grid-container');
		// instafeedGrid.style = "display: flex !important; gap: 21px"

		// setTimeout(() => {
		// 	const instafeedGridItems = document.querySelectorAll('.ingtagram-grid-item');
		// 	instafeedGridItems.forEach((item) => {
		// 		item.style = "width:284px;height:284px;max-width:284px;min-width:284px"
		// 	});
		// }, 3000);
	}
}, 500);

// Get the modal
var modal = document.getElementById("video-modal");
var searchModal = document.getElementById("search-modal");
var wishListModal = document.getElementById("wishlist-modal");
var video = document.getElementById("video-player");
var productQuickView = document.getElementById("modal-quick-view");

// Get the video buttons that opens the modal
var videoModalBtns = document.querySelectorAll(".video-modal-btn");
videoModalBtns.forEach((btn) => {
	btn.onclick = function() {
		modal.style.display = "flex";
		video.src = `https://www.youtube.com/embed/${btn.id}`
	}
});

// Get the search button 
var searchBtn = document.getElementById("header-search-btn");
searchBtn.onclick = function() {
	searchModal.style.display = "flex";
}
// Get the mobile search button
var mobileSearchBtn = document.getElementById("header-mobile-search-btn");
mobileSearchBtn.onclick = function() {
	searchModal.style.display = "flex";
}

// Get the <span> element that closes the modal
var closeButtons = document.querySelectorAll(".close-modal");

// When the user clicks on <span> (x), close the modal
closeButtons.forEach((span) => {
	span.onclick = function() {
		modal.style.display = "none";
		searchModal.style.display = "none";
		wishListModal.style.display = "none";
	}
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
  if (event.target == searchModal) {
    searchModal.style.display = "none";
  }
  if (event.target == wishListModal) {
    wishListModal.style.display = "none";
  }
  if (event.target == productQuickView) {
		event.preventDefault();
		var modal = productQuickView.closest('.modal');
		modal.setAttribute('aria-hidden','true');
		modal.querySelector('.modal__inner').innerHTML = '';
		document.querySelector('body').classList.remove('show_overlay');
  }
}